import React, { useState } from 'react';
import './Option.css';

const Option = ({ option, handleSelected }) => {

    return (
        <div className="options-container">
            <h3 onClick={() => handleSelected(option)} className='bg-slate-400 text-xl font-semibold m-5 py-5'>{option}</h3>
        </div>
    );
};

export default Option;